export {
    AccessErrorPlaceholderIcon,
    AuthErrorPlaceholderIcon,
    NoPreviewPlaceholderIcon,
} from './assets';
